import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';
import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const PropertyLog: React.FC<UserActionLog> = ({ body }) => {
  const { brand } = useServerInfo();
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (body.brand) {
          const fields = FieldsReplacer(brand, body, [
            {
              from: 'name',
              to: 'brand',
            },
          ]);

          setLogFields({ ...logFields, ...fields });
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
